import React from 'react';

import { ToastContainer, toast, cssTransition } from 'react-toastify';

import { withStyles } from '@mui/styles';
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';
import CloseFullscreenRoundedIcon from '@mui/icons-material/CloseFullscreenRounded';

import { Button } from '@mui/material';

import LoaderNew from '../../common/LoaderNew';
import styles from './NotificationsContainerStyles';
import ComponentWrapper from '../../common/ComponentWrapper';

class NotificationsContainer extends ComponentWrapper {
  state = {
    loadingNotifBtns: [],
    timestamp: Date.now(),
    isMinimized: false,
  };

  statusToastId = null;

  toggleToastHeight = () => {
    const { classes } = this.props;

    this.setState(
      (prevState) => ({ isMinimized: !prevState.isMinimized }),
      () => {
        toast.update(this.statusToastId, {
          className: `${classes.notificationGoToTalks} ${
            this.state.isMinimized ? classes.toastMinimized : classes.toastNormal
          }`,
        });
      }
    );
  };

  stopNotificationLoadingBtn = (argKey) => {
    const loadingNotifBtnsCopy = [...this.state.loadingNotifBtns];
    const loadingBtnIndex = loadingNotifBtnsCopy.findIndex((btn) => btn === argKey);
    loadingNotifBtnsCopy.splice(loadingBtnIndex, 1);

    this.setState({ loadingNotifBtns: loadingNotifBtnsCopy });
  };

  runMacro = (pid, eid) => {
    if (!pid || !eid) return;
    const { loadingNotifBtns } = this.state;
    const argKey = `${pid}.${eid}`;

    this.setState({ loadingNotifBtns: [...loadingNotifBtns, argKey] }, () => {
      this.postWithData({
        url: `/rest/run_macros`,
        data: { pid, eid },
        cb: (res) => this.stopNotificationLoadingBtn(argKey),
        errorCb: (err) => this.stopNotificationLoadingBtn(argKey),
      });
    });
  };

  notifyStatus = (notification) => {
    const { classes } = this.props;
    const { loadingNotifBtns } = this.state;

    const customTransition = cssTransition({
      enter: classes.customEnter,
      exit: classes.customExit,
      duration: 1,
    });

    const shouldMinimize = notification.length > 1;
    if (!shouldMinimize) this.setState({ isMinimized: false });

    const NotificationComponent = ({ toggleHeight, showMinimizeIcon }) => (
      <div
        style={{ display: 'flex', alignItems: 'center', padding: '0px', overflow: 'hidden', justifyContent: 'space-between' }}
      >
        <div className={`${classes.fillAvailable}`} style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ position: 'absolute', left: 0, top: 0 }}>
            {showMinimizeIcon &&
              <div onClick={toggleHeight} style={{ cursor: 'pointer', alignSelf: 'start' }}>
                {this.state.isMinimized ?
                  <OpenInFullRoundedIcon style={{ fontSize: 12, color: '#fff' }} /> :
                  <CloseFullscreenRoundedIcon style={{ fontSize: 12, color: '#fff' }}
                />}
              </div>
            }
          </div>
          {notification.map((mes, index) => (
            <div key={index} className={`${classes.notificationRow} ${classes.spaceBetween} ${classes.nowrap}`} style={{ margin: '2px 5px', backgroundColor: '#222029' }}>
              <span style={{ margin: '3px 10px 2px 3px' }}>{mes.title || ''}</span>
              <div className={`${classes.alignCenter}`}>
                {mes.macro_args && mes.macro_args.map((arg, argIndex) => {
                  const argKey = `${arg.pid}.${arg.eid}`;
                  const isLoading = loadingNotifBtns.includes(argKey);

                  return (
                    <div key={`${argKey}.${argIndex}`} className={`${classes.ml5}`}>
                      <Button
                        onClick={() => this.runMacro(arg.pid, arg.eid)}
                        className={`notif-btn ${classes.notificationActionBtn}`}
                      >
                        {isLoading ? <LoaderNew style={{ zoom: 0.8 }} /> : arg.btn_title}
                      </Button>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        <div className={classes.loaderLine}></div>
      </div>
    );

    // Dismiss only if `statusToastId` is active and scoped to the statusContainerId
    if (this.statusToastId && toast.isActive(this.statusToastId)) {
      toast.dismiss(this.statusToastId, { containerId: 'statusContainer' });
    }

    // Display the toast and store the specific ID
    this.statusToastId = toast.info(
      <NotificationComponent
        toggleHeight={this.toggleToastHeight}
        showMinimizeIcon={notification.length > 1}
      />,
      {
        containerId: 'statusContainer',
        position: 'top-center',
        autoClose: false,
        newestOnTop: true,
        closeOnClick: false,
        pauseOnHover: false,
        closeButton: false,
        draggable: false,
        transition: customTransition,
        className: `${classes.notificationGoToTalks} ${this.state.isMinimized ? classes.toastMinimized : classes.toastNormal}`,
      }
    );
  };

  componentDidMount() {
    this.eventSource = new EventSource('/rest/get_user_processes');
    this.eventSource.addEventListener('message', event => {
      const parsedData = event.data ? JSON.parse(event.data) : null;

      // Dismiss only if `statusToastId` is active and scoped to the statusContainerId
      if (this.statusToastId && toast.isActive(this.statusToastId)) {
        toast.dismiss(this.statusToastId, { containerId: 'statusContainer' });
      }

      if (parsedData && Array.isArray(parsedData) && parsedData.length >= 1) this.notifyStatus(parsedData);
    });
    this.eventSource.onerror = () => this.eventSource.close();
    window.addEventListener('beforeunload', () => this.eventSource.close());
  };

  componentWillUnmount() {
    if (this.eventSource) this.eventSource.close();

    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.statusToastId = null;
  };

  handleBeforeUnload = () => {
    if (this.eventSource) this.eventSource.close();
  };

  render() {
    return (
      <div>
        <ToastContainer containerId="statusContainer"/>
        {this.props.children}
      </div>
    );
  }
};

export default withStyles(styles)(NotificationsContainer);
